import * as React from 'react';

const Accomodation = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={10} height={10} fill="none" viewBox="0 0 10 10" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m5.318.178 4.5 4.5a.47.47 0 0 1 .15.35v3.5a1.5 1.5 0 0 1-1.5 1.5h-7a1.5 1.5 0 0 1-1.5-1.5v-3.5a.47.47 0 0 1 .15-.35l4.5-4.5a.48.48 0 0 1 .7 0m.9 5.682h-2.5v4.166h2.5z"
            clipRule="evenodd"
        />
    </svg>
);
export default Accomodation;
